
import { mixins, Options } from 'vue-class-component'
import { maska } from 'maska'
import AppMixin from '@/components/app/mixins/AppMixin.vue'
import BaseFormMixin from '@/components/common/mixins/BaseFormMixin.vue'
import { constant } from '@/utils/constants'
import { IDateRangePicker } from '@/utils/types'
import { Prop, Watch } from 'vue-property-decorator'
import moment from 'moment'
import useQuasar from 'quasar/src/composables/use-quasar.js';
import DateRangePicker from 'vue3-daterange-picker'
import { localeData, localeRanges } from '@/utils/datetime'
@Options({
  components: { DateRangePicker },
  directives: { maska },
  emits: ['update:onChangeDateRange', 'update:modelValue'],
})
export default class DateRangeSelectorV2 extends mixins(AppMixin, BaseFormMixin) {
  @Prop()
  modelValue!: IDateRangePicker

  @Prop()
  disable!: boolean

  @Prop({ default: 'left' })
  opens!: string

  @Prop()
  displayLabel!: boolean

  @Prop({ default: 24 })
  iconSize!: number

  @Prop({ default: 12 })
  fontSize!: number

  @Prop()
  isClear!: boolean

  @Prop({ default: '#3982c2' })
  color!: string

  dateFormat = 'YYYY-MM-DD'
  customLocale = localeData(this.dateFormat)
  customRanges = localeRanges()
  dateRange: IDateRangePicker = {
    startDate: '',
    endDate: '',
  }

  date_range = constant.DATE_RANGE
  quasar = useQuasar()

  get value() {
    return this.modelValue
  }

  set value(value) {
    this.$emit('update:modelValue', value)
  }

  get wrapperStyle() {
    return {
      '--picker-border-color': this.color,
    }
  }

  onClearDateRangeChange() {
    this.dateRange = {
      startDate: '',
      endDate: '',
    }

    this.$emit('update:onChangeDateRange', this.dateRange)
  }

  changeDateRange(data: IDateRangePicker) {
    const check = this.checkRange(data.startDate, data.endDate)

    if (check) {
      this.$emit('update:onChangeDateRange', data)
    }
  }

  checkRange(start, end) {
    const from = moment(start, this.dateFormat)
    const to = moment(end, this.dateFormat)
    const diff = to.diff(from, 'days')
    if (diff > this.date_range) {
      this.quasar.notify({
        type: 'negative',
        message: this.$t('errors.over_92_days'),
      })
      return false
    } else {
      return true
    }
  }

  formatDate(date) {
    if (date.startDate && date.endDate) {
      return moment(date.startDate).format(this.dateFormat) + ' - ' + moment(date.endDate).format(this.dateFormat)
    } else {
      return this.dateFormat + ' - ' + this.dateFormat
    }
  }

  onSelect(data) {
    data.clickApply()
    this.changeDateRange(this.dateRange)
  }

  parseDateRange(range) {
    const [startDate, endDate] = range.split(' - ')
    return { startDate, endDate }
  }

  @Watch('value')
  valueChange() {
    if (this.value) {
      this.dateRange.startDate = this.value.startDate
      this.dateRange.endDate = this.value.endDate
    }
  }

  created() {
    // Only set if modelValue (this.value) exists
    if (this.value) {
      this.dateRange.startDate = this.value.startDate
      this.dateRange.endDate = this.value.endDate
    }
  }
}
